<template>
  <v-card
    color="blue-grey darken-1"
    dark
    :loading="loading"
    height="100%"
  >
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="green lighten-3"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-img
      height="200"
      src="https://cdn.vuetifyjs.com/images/cards/dark-beach.jpg"
      class="mb-4"
    >
      <v-row class="pt-8" align="center" justify="center">
        <v-col class="text-center pb-1" cols="6">
          <h3 class="headline" >Welcome {{user ? user.get('name'): ''}}</h3>
        </v-col>
      </v-row>
      <v-row class="" align="center" justify="center">
        <v-col class="text-center pt-0" cols="8">
          <span class="grey--text text--lighten-1">You are browsing public lists</span>
        </v-col>
      </v-row>
      <v-row v-if="!user" class="" align="center" justify="center">
        <v-col class="text-center pt-0" cols="8">
          <v-btn small color="green lighten-1" class="grey--text text--lighten-3" to="/login">Log In</v-btn>
        </v-col>
      </v-row>
    </v-img>
    <v-row justify="space-between" align="center" >
      <span class="subtitle pl-6">Public Lists</span>
      <v-btn v-if="false" color="green lighten-1" small class="subtitle mr-6" @click="createNewList()">Create New List</v-btn>
    </v-row>
    <list :myLists="myLists"/>
    <v-divider class="mt-4"></v-divider>
    <v-card-actions>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import List from "@/components/List.vue"

export default {
  props: ['objectId'],
  data() {
    return {
    };
  },
  components: {
    'list': List
  },
  methods: {
    ...mapActions(['getPublicLists', 'createNewList'])
  },
  computed: {
    ...mapState(['myLists', 'loading', 'user']),
  },
  mounted () {
    this.getPublicLists()
  },
  watch: {
  },
};
</script>
